interface BGProps {
  bgImage?: string;
  bgVideo?: string;
  children: React.ReactNode;
}

const BG = (props: BGProps) => {
  const { bgImage, bgVideo } = props;

  return (
    <div
      style={{
        width: "1920px",
        height: "1080px",
        ...(bgImage
          ? {
              background: `url(${require(`../../Assets/images/${bgImage}`)})`,
              backgroundSize: "cover",
            }
          : {}),
      }}
    >
      {bgVideo && <video style={styles.bgVideo} autoPlay muted loop src={require(`../../Assets/${bgVideo}`)} />}
      {props.children}
    </div>
  );
};

const styles = {
  bgVideo: {
    position: "absolute" as React.CSSProperties["position"],
    zIndex: -1,
  },
};

export default BG;
